/* eslint-disable react-hooks/exhaustive-deps */
import {useTranslation} from "react-i18next"
import debounce from "debounce-promise"
import {marketingCampaignsService} from "services"
import {KlassDropAsyncPaginate, KlassDropdownAsyncProps} from "../Select"
import {useQueryClient} from "@tanstack/react-query"

type Props = Partial<KlassDropdownAsyncProps> & {
    componentKey?: string
}

export function CampaignSelect(props: Props) {
    const {t} = useTranslation(["common"])
    const queryClient = useQueryClient()

    const loadOptions = debounce(async (search, loadedOptions) => {
        const pageSize = 10
        const page = Math.ceil(loadedOptions.length / pageSize) + 1

        const queryKey = ["campaigns", search, page, props.componentKey]
        const cachedData = queryClient.getQueryData(queryKey, {exact: true})
        if (cachedData) {
            return cachedData
        }

        const params = {
            range: {
                page,
                pageSize
            },
            filter: {
                search
            }
        }
        const {data, total} = await marketingCampaignsService.getAllMarketingCampaigns(params)
        const formatted = {
            options: data,
            hasMore: loadedOptions.length < total
        }

        queryClient.setQueryData(queryKey, formatted)
        return formatted
    }, 500)

    const formatLabel = (option) => {
        if (!option) return ""
        return option.code ? `[${option.code}] ${option.name}` : option.name
    }

    return (
        <KlassDropAsyncPaginate
            {...props}
            placeholder={props.placeholder || t("selectField.placeholder")}
            loadOptions={loadOptions}
            getOptionLabel={formatLabel}
        />
    )
}
